import { Component, OnInit } from '@angular/core';
import { hideSpinner, showSpinner } from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { HistorialComprometidaOrden } from '../models/historial-comprometida-orden.model';
import { LogisticaService } from '../services/logistica.service';

@Component({
  selector: 'app-consulta-historial-comprometida',
  templateUrl: './consulta-historial-comprometida.component.html',
  styleUrls: ['./consulta-historial-comprometida.component.scss']
})
export class ConsultaHistorialComprometidaComponent implements OnInit {

  ordenes: HistorialComprometidaOrden[] = []
  doc?: number;

  constructor(
    private logiticaService: LogisticaService,
    private helpers: HelpersService) { }

  ngOnInit(): void {
  }

  async ObtenerHistorialComprometidasOrdenes(doc: number) {
    var obj_response = await this.logiticaService.getConsultaHistorialComprometidasOrdenes(doc);
    if (obj_response.success === true) {
      this.ordenes = obj_response.data;
    }
  }

  consultar(event) {
    showSpinner()
    const filterValue = (event.target as HTMLInputElement).value;
    this.doc = parseInt(filterValue);
    
    this.ObtenerHistorialComprometidasOrdenes(this.doc);
    hideSpinner()
  }
}
